import React from 'react';
import { catalogNumberFor } from '../orderingModel';

export const CatalogueNumberField = ({ data, set, kind = 'fixture', testid }) => <div className="field">
  <label className="field-label" htmlFor={testid}>Catalogue number</label>
  <div style={{ display: 'flex', gap: 6, minWidth: 0 }}>
    <input id={testid} className="input" data-testid={testid} style={{ minWidth: 0 }} value={catalogNumberFor(data, kind)}
      onChange={e => set(['catalogNumberOverride'], e.target.value)} />
    <button type="button" className="btn btn-sm" title="Use generated catalogue number" aria-label="Use generated catalogue number" data-testid={testid + '-reset'}
      disabled={typeof data.catalogNumberOverride !== 'string'} onClick={() => set(['catalogNumberOverride'], null)}>↻</button>
  </div>
  <div className="field-hint" data-testid={testid + '-mode'}>{typeof data.catalogNumberOverride === 'string' ? 'Custom catalogue number' : 'Generated from ordering selections'}</div>
</div>;